<style lang="scss" scoped>
// @import 'common/sass/reuse.SCSS';
.handle {
  margin: 25px;
  .addBtn {
    margin-left: 20px;
  }
  .handle-row {
    width: 100%;
  }
  .empty {
    padding: 20px;
  }
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 10px;
  width: 50%;
}
.el-select {
  width: 100%;
}
/deep/ .el-drawer__body {
  overflow-y: auto;
}

.description{
    height: 40px;
    line-height: 40px;
    font-size: 15px;
  }
</style>

<template>
  <div class="maintenance-box">
    <div class="panel">
      <el-row class="handle">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addBtn">
          <el-button type="primary" class="handle-row" icon="el-icon-circle-plus" @click="openConfigWindow">{{ language.addBtnTxt }}</el-button>
        </el-col>
      </el-row>
      <el-row v-loading="configLoading">
        <el-table :data="confListPaging" border>
          <template v-for="(v, i) in language.accHead">
            <el-table-column :label="v.value" :key="i">
              <template slot-scope="scope">
                <el-input v-if="v.writable" type="textarea" maxlength="255" v-model="scope.row[v.key]"></el-input>
                <span v-else>{{ scope.row[v.key] }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column :label="language.lastTableColumnTxt" width="120px">
            <template slot-scope="scope">
              <el-button v-if="scope.row.group != rerunKey" type="danger" icon="el-icon-delete" circle @click="deletePositionConfig(scope.row.group)"></el-button>
              <el-button type="primary" icon="el-icon-edit" circle @click="updateAccount(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row class="handle">
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
          <div class="empty"></div>
        </el-col>
        <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="9">
          <el-pagination
            :current-page="pageNum"
            :page-size="pageSize"
            :page-sizes="[5, 10, 25, 50]"
            :pager-count="5"
            :total="total"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <el-row class="description">
        <el-col class="description">
            <el-icon class="el-icon-info"></el-icon>{{language.descriptionTxt}}
        </el-col>
    </el-row>
    <!-- add config window -->
    <el-dialog :title="language.addDialogTitle" :visible.sync="configWindow" :before-close="(done) => {}" :show-close="false">
      <el-form :model="confForm" :rules="rules" ref="confForm" label-position="top">
        <el-form-item :label="language.addGroupTxt" prop="group">
            <el-select :disabled="updateGroup == rerunKey" v-model="confForm.group" filterable :placeholder="language.formSelectDefaultTxt">
                <el-option 
                    v-for="item in groupList" 
                    :disabled="disabledGroups.includes(item.GROUP) || item.GROUP == 'manager'" 
                    :key="item.GROUP" 
                    :label="item.GROUP" 
                    :value="item.GROUP"
                >
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="language.addEquityTxt" prop="equityValve">
            <el-input :disabled="updateGroup == rerunKey" v-model="confForm.equityValve"></el-input>
        </el-form-item>
        <el-form-item :label="language.addLeveragelteTxt" prop="leverageLte">
            <el-input :disabled="updateGroup == rerunKey" v-model.number="confForm.leverageLte"></el-input>
        </el-form-item>
        <el-form-item :label="language.addLeveragegtTxt" prop="leverageGt">
            <el-input v-model.number="confForm.leverageGt"></el-input>
        </el-form-item>
        <el-form-item :label="language.addEnableTxt" prop="enable">
            <el-switch v-model="confForm.enable" active-value="1" inactive-value="0" :active-text="language.yesTxt" :inactive-text="language.noTxt"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetFilledConfig">{{ language.formCancelTxt }}</el-button>
        <el-button type="primary" @click="addLeverageConfig">{{ language.formConfirmTxt }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { 
    URL_GROUP_LIST,
    URL_ADDORUPDATE_LEVERAGE_CONFIG,
    URL_DELETE_LEVERAGE_CONFIG,
    URL_GET_LEVERAGE_CONFIG
} from 'api/api'
const data = () => {
    return {
        confListPaging: [],
        confList: [],
        configLoading: false,
        configWindow: false,
        confForm: {
            group: null,
            equityValve: null,
            leverageLte: null,
            leverageGt: null,
            enable: '1'
        },
        groupList: [],
        updateGroup: null,
        disabledGroups: [],

        pageNum: 1,
        pageSize: 5,
        total: 0,
        rerunKey: 'Rerun_Program'
    }
}

const mixins = [
    require('common/mixin/base').base({ language: 'autoUpdateLeverage' }), 
    require('common/mixin/base').base({ reuse: 'reuse' })
]

const computed = {
    tableHead() {
        return this.language.tableHead
    },
    rules() {
        const language = this.language;
        const rules = {
            group: [
                { 
                    required: true, 
                    validator: (rule, value, callback) => {
                        if(!value) callback(language.groupRulesRequired)
                        else callback()
                    }, 
                    trigger: 'change' 
                },
            ],
            equityValve: [
                this.requiredRule(language.equityRulesRequired),
                this.numberRule(language.equityRulesNumber)
            ],
            leverageLte: [
                this.requiredRule(language.leverageLteRulesRequired),
                this.numberRule(language.leverageLteRulesNumber)
            ],
            leverageGt: [
                this.requiredRule(language.leverageGtRulesRequired),
                this.numberRule(language.leverageGtRulesNumber)
            ]
        }
        return rules
    },
}

const created = function () {
    this.$http.get(URL_GROUP_LIST).then(res => this.groupList = res.data.data)
    this.getLeverageConfig()
}

const methods = {
    addLeverageConfig() {
        this.$refs['confForm'].validate((valid) => {
            if (valid) {
                const modifyBy = JSON.parse(sessionStorage.getItem('user') || '{}').name
                const addObj = {
                    modifyBy, 
                    ...this.confForm
                }
                const isAdd = this.updateGroup != addObj.group
                const successKey = isAdd ? 'addSuccess' : 'updateSuccess'
                const failedKey = isAdd ? 'addFailed' : 'updateFailed'

                this.$http.post(URL_ADDORUPDATE_LEVERAGE_CONFIG, addObj).then((res) => {
                    const code = res.data.data
                    if (code === 9000) this.$message({ message: this.language[successKey], type: 'success' })
                    else this.$message({ message: this.language[failedKey], type: 'error' })
                    this.getLeverageConfig()
                    this.resetFilledConfig()
                })
            }
        })
    },
    getLeverageConfig() {
        this.configLoading = true
        this.disabledGroups = []
        this.$http.get(URL_GET_LEVERAGE_CONFIG).then((res) => {
            const result = res.data.data
            this.confList = result
            this.confList.forEach(conf => {
                this.disabledGroups.push(conf.group)
                const enableKey = conf.enable == '1' ? 'yesTxt' : 'noTxt'
                conf.enableDesc = this.language[enableKey]
            })
            this.total = result.length
            this.slicData()
            this.configLoading = false
        })
    },
    updateAccount(row) {
        const group = row.group
        const updateObj = { group, equityValve: row.equity_valve, leverageLte: row.leverage_lte, leverageGt: row.leverage_gt, enable: row.enable}
        this.configWindow = true
        this.$nextTick(function(){
            Object.assign(this.confForm, updateObj)
            this.updateGroup = group
        })
    },
    deletePositionConfig(group) {
        const lg = this.language
        this.$confirm(`${lg.deleteMsgTxt}`, lg.notifyTxt, { confirmButtonText: lg.formConfirmTxt, cancelButtonText: lg.formCancelTxt, type: 'warning' }).then(() => {
            this.$http.delete(URL_DELETE_LEVERAGE_CONFIG, { params: { group } }).then((res) => {
                const code = res.data.data
                if (code == 9000) {
                    this.$message({ message: lg.delSuccess, type: 'success' })
                    // 第N页删除后页码需要减一
                    const countAfterDelete = this.total - 1
                    if(countAfterDelete % this.pageSize === 0) this.pageNum -= countAfterDelete / this.pageSize
                    this.getLeverageConfig()
                } else {
                    this.$message({ message: lg.delFailed, type: 'info' })
                }
            })
        })
    },
    openConfigWindow() {
        this.configWindow = true
        this.$refs['confForm'].resetFields()
    },
    resetFilledConfig() {
        this.configWindow = false
        this.updateGroup = null
    },
    handlePageChange(val) {
        this.pageNum = val
        this.slicData()
    },
    handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.confListPaging = this.confList.slice(0, this.pageSize)
    },
    slicData() {
        this.confListPaging = this.confList.slice((this.pageNum - 1) * this.pageSize, this.pageNum * this.pageSize);
    },
    requiredRule(message) {
        return { required: true, message, trigger: 'blur' };
    },
    numberRule(message) {
        const numberRule = {
            type: 'number',  
            validator: (rule, value, callback) => {
                if(value > 0) callback()
                else callback(message)
            }, 
            trigger: 'blur'
        };
        return numberRule;
    }
}

const watch = {
  language() {
    this.confListPaging.forEach(conf => {
        const enableKey = conf.enable == '1' ? 'yesTxt' : 'noTxt'
        conf.enableDesc = this.language[enableKey]
    })
  }
}

export default {
    data,
    mixins,
    computed,
    created,
    methods,
    watch
}
</script>


// WEBPACK FOOTER //
// src/views/report/auto-update-leverage.vue